import { identity } from '../../utils/fp/identity.js';
import { targetMatchPattern } from './targetMatchPattern.js';
export const filterBlocks = (blocksWithProps, filtrationState) => (normalize = identity) => blocksWithProps
    ?.filter(([, content]) => targetMatchPattern(filtrationState, normalize(content) || {}))
    .map(([block]) => block);
//# sourceMappingURL=filterBlocks.js.map